import { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { Toaster } from './components/ui/toaster';
import Home from './pages/Home';
import Destinations from './pages/Destinations';
import Services from './pages/Services';
import Certified from './pages/Certified';
import FindTeam from './pages/FindTeam';
import RealWeddings from './pages/RealWeddings';
import MirrorAI from './pages/MirrorAI';
import About from './pages/About';
import Journal from './pages/Journal';
import Contact from './pages/Contact';
import PlanWedding from './pages/PlanWedding';
import AdminEnquiries from './pages/AdminEnquiries';
import AuthCallback from './pages/AuthCallback';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function SiteRoutes() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/destinations" element={<Destinations />} />
        <Route path="/services" element={<Services />} />
        <Route path="/certified" element={<Certified />} />
        <Route path="/team" element={<FindTeam />} />
        <Route path="/real-weddings" element={<RealWeddings />} />
        <Route path="/mirror-ai" element={<MirrorAI />} />
        <Route path="/about" element={<About />} />
        <Route path="/journal" element={<Journal />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/plan" element={<PlanWedding />} />
      </Routes>
      <Footer />
    </>
  );
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes('session_id=')) return <AuthCallback />;
  if (location.pathname.startsWith('/admin')) return <AdminEnquiries />;
  return <SiteRoutes />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <AppRouter />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
